<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col md="6">
            <v-img :src="require('@/assets/imgs/welcome.svg')" fluid></v-img>
          </v-col>
          <v-col cols="12" sm="8" md="4">
            <!-- <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Login form</v-toolbar-title>
              </v-toolbar> -->
            <v-img
              :src="require('@/assets/imgs/wellspring.png')"
              fluid
              width="50%"
              class="mx-auto"
            ></v-img>
            <h3 class="mt-10 px-5">Admin Panel</h3>
            <v-form @submit.prevent="handleLogin">
              <v-card-text>
                <v-alert v-if="globalServerErrors" dense outlined type="error">
                  <p
                    class="mb-0"
                    v-for="globalErr in globalServerErrors"
                    :key="globalErr"
                    v-html="globalErr[0]"
                  ></p>
                </v-alert>
                <v-alert
                  v-if="notification && notification.text"
                  dense
                  outlined
                  type="error"
                >
                  <p class="mb-0" v-text="notification.text"></p>
                </v-alert>
                <form-group
                  name="email"
                  :validator="$v.email"
                  attribute="fields.email"
                >
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      v-bind="attrs"
                      v-model="email"
                      solo
                      placeholder="Enter your mail"
                      @input="$v.email.$touch()"
                      type="email"
                    >
                    </v-text-field>
                  </template>
                </form-group>

                <form-group
                  name="password"
                  :validator="$v.password"
                  attribute="fields.password"
                >
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      v-bind="attrs"
                      v-model="password"
                      solo
                      placeholder="Enter your password"
                      @input="$v.password.$touch()"
                      type="password"
                    >
                    </v-text-field>
                  </template>
                </form-group>
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  :load-recaptcha-script="true"
                  sitekey="6LcbJLUUAAAAAEMe46MD8_9E17C3f6zmyLiDnp4q"
                  size="checkbox"
                >
                </vue-recaptcha>
                <!-- sitekey="6LcbJLUUAAAAAEMe46MD8_9E17C3f6zmyLiDnp4q" live -->
                <!-- sitekey="6Lc_7MAUAAAAAJ9AxZoRfTpiL62Y-leJyU3huR7V" test -->
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <!--  -->
                <!-- :disabled="!verified" -->
                <v-btn
                  :disabled="!verified"
                  color="primary"
                  width="100%"
                  large
                  type="submit"
                >
                  {{ $t("form_box.login") }}</v-btn
                >
              </v-card-actions>
            </v-form>
            <!-- </v-card> -->
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";
export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: {
      required,
      minLength: minLength(6),
    },
  },
  components: {
    "vue-recaptcha": VueRecaptcha,
  },
  computed: {
    ...mapGetters({
      notification: "notification",
    }),
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  data() {
    return {
      email: "",
      password: "",
      robot: false,
      verified: false,
      loading: false,
      redirect: undefined,
      globalServerErrors: null,
    };
  },
  methods: {
    handleLogin() {
      // let data = {
      //   email: this.email,
      //   password: this.password,
      // };
      // this.$store
      //   .dispatch("LoginByEmail", data)
      //   .then(() => {
      //     this.$router.push({ path: this.redirect || "/dashboard" });
      //     this.loading = false;
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //     this.globalServerErrors = err.response.data.errors;
      //     this.scrollTop();
      //   });

      if (this.robot) {
        if (this.$v.$invalid) {
          return;
        } else {
          let data = {
            email: this.email,
            password: this.password,
          };
          this.$store
            .dispatch("LoginByEmail", data)
            .then(() => {
              this.$router.push({ path: this.redirect || "/dashboard" });
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              this.globalServerErrors = err.response.data.errors;
              this.scrollTop();
            });
        }
      }
    },
    onVerify(response) {
      this.verified = true;
      if (response) {
        this.robot = true;
      }
    },
    onExpired() {
      this.verified = false;
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
